import { render } from "./OurRecent.vue?vue&type=template&id=8586a5ac"
import script from "./OurRecent.vue?vue&type=script&lang=js"
export * from "./OurRecent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__